import { render } from "./Rotation.vue?vue&type=template&id=1a3cdf34"
import script from "./Rotation.vue?vue&type=script&lang=js"
export * from "./Rotation.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__